export default __webpack_public_path__ + "static/media/BT_Icons_Hub_Fill.9fe8c58f.svg";